import { Box, Text } from '@chakra-ui/react';
import { useLayoutEffect, useRef, useState } from 'react';
import { pageTitleProps } from '@/theme/sitePageTypography';

const TITLE_MAX_PX = 18;
const TITLE_MIN_PX = 11;

/** Largest title size that keeps wrapped text readable for this width and name length. */
function pickLeagueTitleFontSize(contentWidth: number, leagueName: string): number {
  if (contentWidth <= 0) {
    return TITLE_MAX_PX;
  }

  const nameLength = leagueName.length;
  const charsPerTenPx = nameLength / Math.max(contentWidth / 10, 1);

  if (charsPerTenPx <= 1.25) return TITLE_MAX_PX;
  if (charsPerTenPx <= 1.75) return 16;
  if (charsPerTenPx <= 2.4) return 14;
  if (charsPerTenPx <= 3.2) return 12;
  return TITLE_MIN_PX;
}

export function LeaguePageTitle(props: { leagueName: string }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [fontSizePx, setFontSizePx] = useState(TITLE_MAX_PX);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const update = () => {
      setFontSizePx(pickLeagueTitleFontSize(container.clientWidth, props.leagueName));
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(container);
    return () => observer.disconnect();
  }, [props.leagueName]);

  return (
    <Box ref={containerRef} w='full' minW={0}>
      <Text
        {...pageTitleProps}
        textAlign='center'
        w='full'
        fontSize={`${fontSizePx}px`}
        lineHeight='short'
        whiteSpace='normal'
        overflowWrap='anywhere'
      >
        {props.leagueName}
      </Text>
    </Box>
  );
}
